// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_cgxA1","g-price":"g-price"};